// Types personalisés
import BaseTreeNode from "@/types/BaseTreeNode";
import ObjectWidget from "@/types/Dashboard/ObjectDashboard/ObjectWidget";
import Dictionary from "@/types/Dictionary";
import Pin from "@/types/FilterTree/Pin";
// Machine à état 
import { ObjectDashAdminState } from "./IObjectDashAdminState";
import { ObjDashAdminEmpty } from "./ObjDashAdminEmpty";
// Axios pour WebAPI Client
import axios, { AxiosResponse } from "axios";
import { API_URL } from "@/App.settings";
// Lib vue.js
import { Vue } from 'vue-property-decorator';
import ObjectDashboard from "@/types/Dashboard/ObjectDashboard/ObjectDashboard";
import BaseObjectTypeEnum from "@/enums/BaseObjectTypeEnum";


/**
 * Classe représentatant l'état initial du store "ObjectDashboardStore". Nous sommes limité au chargement de l'arborescence
 */
export class ObjDashAdminInitial extends ObjectDashAdminState {
    
    /** Charge l'arbre des objets types dans le store */
    async LoadTree(nodeIdToSelect: string = ""): Promise<void> {
        this.store.context.commit('setIsModified', false);

        const args: Dictionary<any> = {};
		args["Token"] = Vue.cookies.get('access_token') != null ? Vue.cookies.get('access_token') : "";

		try{
			const response: AxiosResponse<any,any> = await axios.post(API_URL + "ObjectDashboard/GetObjectTypes", args);
			if (response && response.data) {
				this.store.context.commit('loadTree', response.data);

                /** On fait avancer la machine a état car le chargement est validé*/
                this.store.context.commit('setLoadState', new ObjDashAdminEmpty(this.store));

				// Si un noeud doit être sélectionné alors on le recherche au préalable
				if (nodeIdToSelect.toString() !== '') {
					let node:BaseTreeNode | null = this.searchNode(nodeIdToSelect, this.store.context.getters['GetAdminTree']);
					if(node){
                        this.store.context.dispatch('SelectDashNode', node); 
                    }
				}
			}
		}catch(err){
			console.error(err);
			throw err;
		}
    }

//#region VIDE CAR : Inutile à cette étape 
    /** Inutile à cette étape */
    public Clear(): void {
        console.debug("ObjDashAdminInitial - Clear()");
    }
    /** Inutile à cette étape */
    async SelectDashNode(dashnode: BaseTreeNode): Promise<void> {
        console.debug("ObjDashAdminInitial - SelectDashNode() - dashnode : ", dashnode);
    }
    /** Inutile à cette étape */
    async CreateDashboard(dashnode: BaseTreeNode, profileIds: number[], pins: Pin[], widgets: ObjectWidget[]): Promise<void> {
        console.debug("ObjDashAdminInitial - CreateDashboard() - dashnode : ", dashnode);
    }
    /** Inutile à cette étape */
    async RemoveDashboard(dashnode: BaseTreeNode): Promise<void> { 
        console.debug("ObjDashAdminInitial - RemoveDashboard() - dashnode : ", dashnode);
    }
    /** Inutile à cette étape */
    async SaveDashboard(dashboard: ObjectDashboard): Promise<void> { 
        console.debug("ObjDashAdminInitial - SaveDashboard() - dashboard : ", dashboard);
    }
    /** Inutile à cette étape */
    AddWidget(widget: ObjectWidget): void { 
        console.debug("ObjDashAdminInitial - AddWidget() - widget : ", widget);
    }
    /** Inutile à cette étape */
    RemoveWidget(widgetId: number): void {
        console.debug("ObjDashAdminInitial - RemoveWidget() - widgetId : ", widgetId);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    async UpdateWidgetParameters(widgetId: number, parameters: any, name: string | undefined): Promise<void> { 
        console.debug("ObjDashAdminInitial - UpdateWidgetParameters() - widgetId : ", widgetId);
    }
    /** Inutile à cette étape : pas de tableau de bord */
    async UpdateWidget(widgetId: number, datas: any) { 
        console.debug("ObjDashAdminInitial - UpdateWidget() - widgetId : ", widgetId);
    }
//#endregion

}